import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidebar-alt',
  templateUrl: './sidebar-alt.component.html',
  styleUrls: ['./sidebar-alt.component.css']
})
export class SidebarAltComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
